<div class="currency-drop {{theme()}}">
  <button class="selected-btn" [matMenuTriggerFor]="currencyMenu" [disabled]="payments.isLoading()" appRipple>@if (type() === 'symbol') {
    <app-currency [currency]="currentCurrency()" />
    }@if (type() === 'text') {
    <span>{{currentCurrency().toUpperCase()}}</span>
    }
    @if (theme() === 'theme3') {
      <app-icon name="arrow_drop_down_rounded" />
    } @else {
      <em class="material-icons">arrow_drop_down</em>
    }
  </button>
    <mat-menu #currencyMenu="matMenu">
      @for (item of supportedCurrencies(); track item) {
        <button [class.active]="item.currency === currentCurrency()" (click)="setCurrency(item.currency || '')" mat-menu-item>@if (type() === 'symbol') {
          <app-currency [currency]="item.currency" />
          }@if (type() === 'text') {
          <span>{{item?.currency?.toUpperCase()}}</span>
        }</button>
      }
    </mat-menu>
  </div>
